
export const BASE_URL = `https://api.vsinfotech.ca/api`
export const IMAGE_URL = `https://api.vsinfotech.ca/`
// export const BASE_URL = `http://localhost:5000/api`
// export const IMAGE_URL = `http://localhost:5000/`